import { StyleProps } from 'fe-components/Box/interface';
import Box from 'fe-design-base/atoms/Box';
import Button from 'fe-design-base/molecules/Button';

import { toI18n } from 'util/i18n';

type BackToTimesheetsProps = StyleProps & {
  onClick: () => void;
};

const BackToTimesheets = ({ onClick, ...styles }: BackToTimesheetsProps) => (
  <Box {...styles}>
    <Button
      variant="tertiary"
      size="small"
      startIcon="ArrowLeft"
      onClick={onClick}
    >
      {toI18n('timecard_modal_v3.embedded.back_to_timesheets')}
    </Button>
  </Box>
);

export default BackToTimesheets;
